import { Component, type ReactNode } from 'react';
import { ErrorScreen } from './ErrorScreen';

interface State {
  error: unknown;
  hasError: boolean;
}

export class AppErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null, hasError: false };

  static getDerivedStateFromError(error: unknown): State {
    return { error, hasError: true };
  }

  render() {
    if (this.state.hasError) return <ErrorScreen error={this.state.error} />;
    return this.props.children;
  }
}
